import React, { FunctionComponent } from "react";
import { IShelving } from "../../../hooks/shelvings";
import { ShelfRepresentation } from "../ShelfRepresentation";
import styles from "./styles.module.scss";
import { IShelf } from "../../../hooks/shelves";
import { IShelfSegment, IShelfSegmentAlbum } from "../../../hooks/shelfSegments";
import { ShelvingUtilities } from "../../../models/ShelvingUtilities";

export const ShelvingRepresentation: FunctionComponent<IShelvingRepresentationProps> = ({
  shelving,
  shelvings,
  setShelvings,
  selectedShelf,
  selectedShelfSegment,
  selectedAlbumIds,
  isLoading,
  setIsLoading,
  onShelfSegmentAlbumSelected,
  onRemoveAlbumFromShelfSegment,
  onShelfSegmentFetched,
  shelvingIndex,
  zoom,
  onModifyShelf,
  onModifyShelfSegment,
  onModifyShelving,
  onFocus,
  onAssignAlbumsToShelfSegmentByFilter,
  isMinimalist
}) => {
  const piperLogo = new URL("../../../images/piper-text.png", import.meta.url).href;
  const shelfRepresentation = (shelf: IShelf, index: number) => (
    <ShelfRepresentation
      key={shelf.uuid}
      shelving={shelving}
      shelvings={shelvings}
      setShelvings={setShelvings}
      shelf={shelf}
      selectedShelfSegment={selectedShelfSegment}
      selectedAlbumIds={selectedAlbumIds}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      onShelfSegmentAlbumSelected={shelfSegmentAlbum => {
        if (onShelfSegmentAlbumSelected) {
          onShelfSegmentAlbumSelected(shelfSegmentAlbum);
        }
      }}
      onRemoveAlbumFromShelfSegment={(album, shelfIndex, segmentIndex, albumIndex) =>
        onRemoveAlbumFromShelfSegment(album, shelvingIndex, shelfIndex, segmentIndex, albumIndex)
      }
      onShelfSegmentFetched={(shelfSegment, shelfIndex, shelfSegmentIndex) => {
        if (onShelfSegmentFetched) {
          onShelfSegmentFetched(shelfSegment, shelvingIndex, shelfIndex, shelfSegmentIndex);
        }
      }}
      shelvingIndex={shelvingIndex}
      shelfIndex={index}
      zoom={zoom}
      canRemove={onRemoveAlbumFromShelfSegment !== undefined}
      onModifyShelf={onModifyShelf}
      onModifyShelving={onModifyShelving}
      onModifyShelfSegment={onModifyShelfSegment}
      onFocus={onFocus}
      onAssignAlbumsToShelfSegmentByFilter={onAssignAlbumsToShelfSegmentByFilter}
      isMinimalist={isMinimalist}
    />
  );
  return (
    <div
      className={styles.cabinet}
      style={{
        borderImage: `url(${ShelvingUtilities.getThemeImage(shelving.theme)}) 100`,
        flexDirection: shelving.orientation == "horizontal" ? "column" : "row",
        height: shelving.orientation == "horizontal" ? "fit-content" : "100%",
        width: shelving.orientation == "horizontal" ? "100%" : "fit-content"
      }}
    >
      {selectedShelf
        ? shelfRepresentation(
            selectedShelf,
            shelving?.shelves?.map(shelf => shelf.uuid).indexOf(selectedShelf.uuid)
          )
        : shelving?.shelves
            ?.sort((a, b) => a.order - b.order)
            .map((shelf, index) => shelfRepresentation(shelf, index))}
      <img className={styles.piperLogo} src={piperLogo} alt={"piper"} />
    </div>
  );
};

export interface IShelvingRepresentationProps {
  shelving: IShelving;
  shelvings: IShelving[];
  setShelvings?: (shelvings: IShelving[]) => void;
  selectedShelf: IShelf;
  selectedShelfSegment: IShelfSegment;
  selectedAlbumIds: string[];
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  onShelfSegmentAlbumSelected?: (shelfSegmentAlbum: IShelfSegmentAlbum) => void;
  onRemoveAlbumFromShelfSegment?: (
    shelfSegmentAlbum: IShelfSegmentAlbum,
    shelvingIndex: number,
    shelfIndex: number,
    shelfSegmentIndex: number,
    albumIndex: number
  ) => void;
  onShelfSegmentFetched?: (
    shelfSegment: IShelfSegment,
    shelvingIndex: number,
    shelfIndex: number,
    shelfSegmentIndex: number
  ) => void;
  shelvingIndex: number;
  zoom: number;
  onModifyShelving?: (shelving: IShelving) => void;
  onModifyShelf?: (shelf: IShelf) => void;
  onModifyShelfSegment?: (shelf: IShelf, segment: IShelfSegment) => void;
  onFocus?: (shelf: IShelf, segment: IShelfSegment) => void;
  onAssignAlbumsToShelfSegmentByFilter?: (shelfSegment: IShelfSegment) => void;
  isMinimalist: boolean;
}
